
import React from 'react';
import { Slider } from '@/components/ui/slider';
import { Label } from '@/components/ui/label';

interface LocationRangeSliderProps {
  value: number;
  onChange: (value: number) => void;
}

export const LocationRangeSlider: React.FC<LocationRangeSliderProps> = ({
  value,
  onChange
}) => {
  const handleSliderChange = (values: number[]) => {
    onChange(values[0]);
  };

  const kmToMiles = (km: number) => {
    return Math.round(km * 0.621371);
  };

  return (
    <div className="space-y-3">
      <Label htmlFor="range-slider">Distance Range</Label>
      <div className="px-3">
        <Slider
          id="range-slider"
          value={[value]}
          onValueChange={handleSliderChange}
          min={1}
          max={500}
          step={1}
          className="w-full"
        />
      </div>
      <div className="text-center">
        <span className="text-sm font-medium text-gray-700">
          Within {value} km ({kmToMiles(value)} miles)
        </span>
      </div>
    </div>
  );
};
